import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isEqual, isArray } from "lodash";

import { getParam, truncate } from '../utils/utils';
import { listItems } from '../utils/utilsCodeList';

import dsd from "../classes/clsDSD";
import * as PD from '../classes/pdStyle';


class ListItems extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Items: null
        };

        this.dsd = new dsd();
    }

    componentDidMount() { this.setup(); }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props, prevProps)) { this.setup(); }
    }

    loadData(filters) {

        const onLoad = function(arr) {
            this.setState({ Items: arr, renderState: 'loaded' });
            if (this.state.onLoad) { this.state.onLoad(arr.length); }
        }.bind(this);

        const onError = function(e) {
            this.setState({ renderState: 'failed', errorMessage: e.message });
        }.bind(this);

        listItems(this.dsd, filters, onLoad, onError);
    }

    setup() {

        let StateChange = {
            filters: {},
            onLoad: null,
            renderState: 'loading'
        };

        if (getParam('filters', this.props))  { StateChange.filters = getParam('filters', this.props); }
        if (getParam('onLoad', this.props))   { StateChange.onLoad  = getParam('onLoad', this.props); }

        this.setState(StateChange);
        this.loadData(StateChange.filters);
    }

    render() {

        if (this.state.renderState === 'failed') {
            return <PD.ErrorBox>A problem has occurred</PD.ErrorBox>;
        }

        if (this.state.renderState === 'loaded') {
            let arr = this.state.Items;
            if (isArray(arr) && arr.length > 0) {
                return (
                    <PD.Table className="list">
                        <PD.Thead>
                            <PD.Tr>
                                <PD.Th>Code</PD.Th>
                                <PD.Th>Label</PD.Th>
                                <PD.Th>Parents</PD.Th>
                                <PD.Th>Definition</PD.Th>
                            </PD.Tr>
                        </PD.Thead>
                        <PD.Tbody>
                            {arr.map((Item, pos) => (
                                <PD.Tr key={pos}>
                                    <PD.Td>
                                        <PD.PdNavLink to={`/item/${Item._id}`}>{Item.code}</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>{Item.label}</PD.Td>
                                    <PD.Td>
                                        {Item.Parents && Item.Parents.map((parent, ppos) => (
                                            parent.ParentItem &&
                                            <div key={ppos}>
                                                <PD.PdNavLink to={`/item/${parent.ParentItem._id}`}>{parent.ParentItem.code}</PD.PdNavLink>
                                            </div>
                                        ))}
                                    </PD.Td>
                                    <PD.Td>
                                        <PD.MdPresent>{truncate(Item.definition, 400)}</PD.MdPresent>
                                    </PD.Td>
                                </PD.Tr>
                            ))}
                        </PD.Tbody>
                    </PD.Table>
                );
            }
        }

        return <div />;
    }
}

export default function ListItems_wrapper(props) {
    const navigation = useNavigate();
    const location  = useLocation();
    const params    = useParams();
    return <ListItems {...props} navigation={navigation} location={location} params={params} />;
}
